import Vue from 'vue';
import { errorLogModule } from '@/store/modules/ModuleErrorLog';
import { isArray } from '@tencent/s2-client-vue-lib';
import settings from '@/AppSettings';

/** destruct */
const { errorLog: needErrorLog }: any = settings;

/** checked */
const checkNeed: any = (): any => {
	const env: any = process.env.NODE_ENV;

	if (isArray(needErrorLog) && env) {
		return needErrorLog.includes(env);
	}

	return false;
};

if (checkNeed()) {
	// eslint-disable-next-line func-names
	Vue.config.errorHandler = function (err: any, vm: any, info: any): any {
		errorLogModule.AddErrorLog({
			err,
			vm,
			info,
			url: window.location.href
		});
	};
}
